import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';

import './styles.css';
import { InfoRelatedContainer } from '../AccountAddress/style';

const AccountProtocols = ({ protocols }) => {
  const history = useHistory();

  const handleOnProtocolNameClick = useCallback(
    ({ protocolId, recordTypeId }) => {
      history.push(`/admin/protocol/${protocolId}/update`, { recordTypeId });
    },
    [history]
  );

  if (!protocols || !protocols.length) return null;

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}
      >
        {protocols.map((protocol) => (
          <InfoRelatedContainer key={protocol.id}>
            <div>
              <span
                className="link-to-protocol-details"
                onClick={() =>
                  handleOnProtocolNameClick({
                    recordTypeId: protocol.recordTypeId,
                    protocolId: protocol.id
                  })
                }
                title={protocol?.title || ''}
                title={protocol?.title || ''}
              >
                {protocol.number}
              </span>
            </div>
            <div className="small">
              <span>
                <span className="font-weight-bold">Criado em: </span>
                {toBrazilianFullDate(protocol.creationDate)}
              </span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Responsável: </span>
              <span>{protocol?.responsibleName || ''}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Tipo de registro: </span>
              <span>{protocol?.recordTypeName || ''}</span>
            </div>
          </InfoRelatedContainer>
        ))}
      </div>
    </>
  );
};

export default AccountProtocols;
